<template>
  <div class="wrapper">
    <div class="logo">
      <router-link to="/">
        <img src="@/assets/images/logo/new_logo.svg" />
      </router-link>
    </div>
    <h1 v-show="!verified && loading">Please wait...</h1>
    <h1 v-show="verify_error">Error while verifying your project,Try again.</h1>
    <button
      v-show="verify_error"
      class="login-btn"
      @click="$router.push({ name: 'login' })"
    >
      Go back
    </button>
    <div class="loader" v-show="loading">
      <img src="@/assets/icons/loading_blue.gif" alt />
    </div>
    <h1 v-show="verified">Redirecting...</h1>
  </div>
</template>
<script>
import * as axios from "axios";

export default {
  name: "project-verification",
  data() {
    return {
      loading: false,
      verified: false,
      verify_error: false,
    };
  },
  computed: {},
  mounted() {
    let vm = this;
    vm.loading = true;
    if (vm.$route.params.issuer && vm.$route.params.project) {
      let issuer = vm.$route.params.issuer;
      let project = vm.$route.params.project;
      window.location.href = vm.$fullUrl(
        "invitation?type=project&issuer=" +
          issuer +
          "&reference=" +
          project +
          "&action=verification"
      );
      vm.loading = false;
      vm.verified = true;
    } else {
      vm.verify_error = true;
      vm.loading = false;
    }
  },
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";
.wrapper {
  width: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  overflow: hidden;
  background: #f2f2f2 url($assets + "/images/backgrounds/logo_stamp2.svg");
  background-size: contain;
  background-repeat: no-repeat !important;
  background-position: center;
  .logo {
    margin-bottom: 80px;
    img {
      width: 150px;
    }
  }
  .login-btn {
    background: #1885ad;
    width: 100px;
    height: 45px;
    outline: none;
    border-radius: 5px;
    padding: 7px;
    color: #fff;
    text-align: center;
  }
}
</style>